<ll-titulo>Generadores Instrumento Diagnostico</ll-titulo>
<generador-diagnostico></generador-diagnostico>